import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiFetch, isModernAuthEnabled } from '../utils/apiClient';

export default function AuthDebug() {
  const { t } = useTranslation();
  const [state, setState] = useState(null);
  useEffect(() => {
    let cancelled = false;
    apiFetch('/auth/session').then(async response => {
      const body = await response.json().catch(() => ({}));
      if (!cancelled) setState({ cookieSessions: isModernAuthEnabled(), status: response.status, authenticated: body.isAuthenticated === true });
    }).catch(() => { if (!cancelled) setState({ status: 0, authenticated: false }); });
    return () => { cancelled = true; };
  }, []);
  return <main className="auth-loading"><h1>{t('authModern.connectionStatus')}</h1><pre>{state ? JSON.stringify(state, null, 2) : t('common.loading')}</pre></main>;
}
